import React, { useState, useEffect } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import "../../styles/practitionerpage.css";
import "../../styles/homepage.css";
import { Link } from "react-router-dom";
import womanQuestion from "../../img/pelvicCareQuestion.png";
import butterfly1 from "../../img/Butterfly1.png";
import { useDispatch } from "react-redux";
import { NewFooter } from "../../components/newFooter";
import "../../styles/pelvicCareQuestion.css";
import { createIndividualOption } from "../../features/individualOptions/individualOptionsSlice";

export const PelvicCareQuestion = () => {
  const dispatch = useDispatch();

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    option: "QUESTION",
    info: "",
  });

  const submitData = (e) => {
    // e.preventDefault()
    if (
      data?.firstName == "" ||
      data?.lastName == "" ||
      data?.email == "" ||
      data?.option != "QUESTION" ||
      data?.info == ""
    ) {
      return console.log("error");
    } else {
      dispatch(createIndividualOption(data));
    }
    // dispatch(createIndividualOption(data))
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  console.log(data);
  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);
  return (
    <div>
      <div className="bg-pelvicCareQuestion">
        <div className="padding-logo-aling pt-4">
          <h2 className="padding-top-userpages fs-48-32-30">
            Ask a Pelvic Care Question
          </h2>
        </div>
        <div className="padding-logo-aling">
          <p className="mt-3 fs-20-18 text-dm">
            Have a question about pelvic care? Or something you’d like to know,
            but were too embarrassed to ask?
          </p>
          <p className="mt-4 fs-20-18 text-dm">
            Send us what’s on your mind and we will help you find answers by
            filling out the form below.{" "}
          </p>
          <p className="m-0 fs-20-18 text-dm padding-right mt-3">
            Don’t want to be identified? No problem. We will answer all
            questions on our blog so you can check back when it suits you.
          </p>
        </div>
        <div className="d-flex justify-content-between  padding-logo-aling">
          <div>
            <div className="align-baseline">
              <div className="d-grid mt-4 mb-4">
                <label className="text-dm">Write your Question</label>
                <textarea
                  className="textarea-waitlist"
                  value={data?.info}
                  name="info"
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="d-grid mt-4">
                <label className="text-dm">First name</label>
                <input
                  className="input-waitlist"
                  value={data?.firstName}
                  name="firstName"
                  onChange={handleChange}
                ></input>
              </div>
              <div className="d-grid mt-4">
                <label className="text-dm">Last name</label>
                <input
                  className="input-waitlist"
                  value={data?.lastName}
                  name="lastName"
                  onChange={handleChange}
                ></input>
              </div>
              <div className="d-grid mt-4">
                <label className="text-dm">Email address</label>
                <input
                  className="input-waitlist"
                  value={data?.email}
                  name="email"
                  onChange={handleChange}
                ></input>
              </div>

              <div className="mt-4 controller-width-text">
                <p className="fs-10 text-dm">
                  I consent to Elana Inc. processing data I provide, so that
                  Elana Inc. can provide services to me. In addition, by
                  clicking ‘Ask a Question’ I acknowledge that I have read and
                  agree to Elana’s Privacy Policy and Terms and Conditions. I
                  agree to receive emails and updates from Elana Inc.
                </p>
              </div>
              <div className="pt-4 pb-4">
                <button
                  className="button-newindividualpage blue-hover"
                  onClick={() => {
                    submitData(data);
                    toggleShow();
                  }}
                >
                  ASK A QUESTION
                </button>
              </div>
            </div>
          </div>
          <div className="">
            <img
              src={womanQuestion}
              className="padding-right align-ima no-phone"
            />
          </div>
        </div>

        {/* //modal  */}
        <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
          <MDBModalDialog size="lg" rounded className="p-5">
            <MDBModalContent className="bg-modal-option">
              <MDBModalBody>
                <div className="d-flex justify-content-end">
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={toggleShow}
                  ></MDBBtn>
                </div>
                <div className="items-controller mt-3 mb-3">
                  <img src={butterfly1} className="butterfly1"></img>
                </div>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Thank you for Asking a Question here at Elana.
                </p>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Check your inbox for an email confirmation. If you've provided
                  one.<br/>Otherwise, check out our blogs frequently for upcoming
                  answers!
                </p>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
      <NewFooter />
    </div>
  );
};
